import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Qué se siente durante SAINT®?",
    answer:
      "Durante SAINT® se siente una pulsación magnética en el cuero cabelludo. El paciente permanece despierto y alerta. Cada sesión de estimulación dura unos minutos.",
  },
];

export const esWhatDoesItFeelLike = makeEsArticle({
  slug: "what-does-saint-tms-feel-like",
  title: "¿Qué se siente durante SAINT® TMS?",
  description:
    "Durante SAINT® se siente una pulsación magnética en el cuero cabelludo. El paciente permanece despierto y alerta durante cada sesión.",
  h1: "¿Qué se siente durante SAINT®?",
  breadcrumbLabel: "Qué se siente en SAINT®",
  shortAnswer:
    "Durante SAINT® se siente una pulsación magnética en el cuero cabelludo, en el sitio donde se coloca la bobina. El paciente permanece despierto y alerta. Cada sesión de estimulación dura unos minutos, y hay descansos de aproximadamente 50 minutos entre sesiones. No se usa anestesia ni sedación. SAINT® está autorizada por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos.",
  keyTakeaways: [
    "Se siente una pulsación magnética en el cuero cabelludo.",
    "El paciente permanece despierto y alerta.",
    "Cada sesión de estimulación dura unos minutos.",
    "No se usa anestesia ni sedación.",
    "SAINT® está autorizada por la FDA para el trastorno depresivo mayor en adultos.",
  ],
  sections: [
    {
      heading: "La experiencia",
      paragraphs: [
        "SAINT® utiliza una bobina magnética colocada sobre el cuero cabelludo. El paciente permanece despierto y alerta, sentado cómodamente. Durante la estimulación se siente una pulsación magnética en el sitio de la bobina. Cada una de las 50 sesiones dura unos minutos.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
